import React from "react";

/**
 * Top-bar icon control (inbox, notifications) with consistent badge placement.
 */
export default function HeaderNavTrigger({
  label,
  onClick,
  children,
  badgeCount = 0,
  badgeMax = 99,
}) {
  const showBadge = Number(badgeCount) > 0;
  const badgeText =
    Number(badgeCount) > badgeMax ? `${badgeMax}+` : String(badgeCount);

  return (
    <div className="text-center d-flex justify-content-center icon-container">
      <li className="wrapper">
        <button
          type="button"
          className="icon-button svg header-nav-trigger"
          onClick={onClick}
          aria-label={label}
        >
          <span className="header-nav-trigger__icon">{children}</span>
          {showBadge ? (
            <span className="header-nav-badge" aria-hidden="true">
              {badgeText}
            </span>
          ) : null}
        </button>
      </li>
      <span className="hover-text">{label}</span>
    </div>
  );
}
